<template>
  <div id="app">
    <div class="">
      <Header></Header>
    </div>
    <div>
      <router-view />
    </div>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.header-occupy {
  height: 110px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue